"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.base */
//================================================================

var _HashBuckets_1 = require("./_HashBuckets");
/**
 * @hidden
 */


var _MapHashBuckets =
/** @class */
function (_super) {
  __extends(_MapHashBuckets, _super);
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */


  function _MapHashBuckets(source, hash, pred) {
    var _this = _super.call(this) || this;

    _this.source_ = source;
    _this.hash_function_ = hash;
    _this.key_eq_ = pred;
    return _this;
  }
  /**
   * @internal
   */


  _MapHashBuckets._Swap_source = function (x, y) {
    var _a;

    _a = __read([y.source_, x.source_], 2), x.source_ = _a[0], y.source_ = _a[1];
  };
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */


  _MapHashBuckets.prototype.hash_function = function () {
    return this.hash_function_;
  };

  _MapHashBuckets.prototype.key_eq = function () {
    return this.key_eq_;
  };
  /* ---------------------------------------------------------
      FINDERS
  --------------------------------------------------------- */


  _MapHashBuckets.prototype.find = function (key) {
    var e_1, _a;

    var index = this.hash_function_(key) % this.size();
    var bucket = this.at(index);

    try {
      for (var bucket_1 = __values(bucket), bucket_1_1 = bucket_1.next(); !bucket_1_1.done; bucket_1_1 = bucket_1.next()) {
        var it = bucket_1_1.value;
        if (this.key_eq_(it.first, key)) return it;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (bucket_1_1 && !bucket_1_1.done && (_a = bucket_1.return)) _a.call(bucket_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return this.source_.end();
  };

  _MapHashBuckets.prototype.hash_index = function (it) {
    return this.hash_function_(it.first) % this.size();
  };

  return _MapHashBuckets;
}(_HashBuckets_1._HashBuckets);

exports._MapHashBuckets = _MapHashBuckets;